export const stateName = 'returnShipment' as const
